<template>
  <div v-if="isRedirecting" class="redirect-loader">
    <div class="redirect-loader__backdrop"></div>
    <div class="redirect-loader__content">
      <div class="redirect-loader__spinner">
        <BaseLoader />
      </div>
      <div class="redirect-loader__text">
        <h3 class="redirect-loader__title">{{ t('common.redirecting.title') }}</h3>
        <p class="redirect-loader__subtitle">{{ t('common.redirecting.subtitle') }}</p>
        <p v-if="redirectTarget" class="redirect-loader__target">
          {{ redirectTarget }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();
const { isRedirecting, redirectTarget } = useRedirectState();
</script>

<style scoped>
.redirect-loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.redirect-loader__backdrop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(4px);
}

.redirect-loader__content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 32px;
  background: var(--white);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  text-align: center;
}

.redirect-loader__spinner {
  width: 48px;
  height: 48px;
}

.redirect-loader__text {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.redirect-loader__title {
  font-size: 18px;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.redirect-loader__subtitle {
  font-size: 14px;
  color: var(--text-secondary);
  margin: 0;
}

.redirect-loader__target {
  font-size: 12px;
  color: var(--text-tertiary);
  font-family: monospace;
  word-break: break-all;
  margin: 0;
  padding: 8px;
  background: var(--grey-6);
  border-radius: 4px;
}
</style>